/**
 * WRITE-mode flag for favorites dual-write (cloud + local v2 on add/toggle).
 *
 * When ON: toggleSamband dual-writes to cloud and local v2.
 * When OFF: toggleSamband uses cloud-only or local-only via meta.legacyWrite.
 *
 * Display (mergedList / isFavorite) is not gated here — archive + migration flags
 * in favoritesStore control legacy display reads. removeSamband is always unified.
 */
export function isUnifiedFavoritesEnabled(): boolean {
  const raw = (import.meta.env.VITE_FAVORITES_UNIFIED as string | undefined) ?? '';
  return raw === 'true' || raw === '1';
}
